<div>
    <div class="textpages__help" :class="{'textpages__help-mobile': userStore.mobile}">
        <div class="textpages__help-content" :class="{'textpages__help-content-mobile': userStore.mobile}">
            <p>
                {{ $t('textpages.help.desc') }}
            </p>
        </div>

        <div class="textpages__help-content" :class="{'textpages__help-content-mobile': userStore.mobile}">
            <h1>{{ $t('textpages.help.statusTitle') }}</h1>
            <p>{{ $t('textpages.help.statusDesc') }}</p>
            <img alt="status" :style="{ 'max-width': userStore.mobile ? '321px' : '960px' }" :src="userStore.mobile ? getImageUrl('statushelpMobile') : getImageUrl('statushelp')" />
        </div>

        <div v-if="localizeStore.hasService('cam')" class="textpages__help-content" :class="{'textpages__help-content-mobile': userStore.mobile}">
            <h1>{{ $t('textpages.help.desktopTitle') }}</h1>
            <p>{{ $t('textpages.help.desktopDesc') }}
            </p>
            <img alt="desktop" :style="{ 'max-width': userStore.mobile ? '321px' : '960px' }" :src="userStore.mobile ? getImageUrl('desktophelpMobile') : getImageUrl('desktophelp')" />
        </div>

        <div v-if="localizeStore.hasService('videocall')" class="textpages__help-content" :class="{'textpages__help-content-mobile': userStore.mobile}">
            <h1>{{ $t('textpages.help.videoCallTitle') }}</h1>
            <p>{{ $t('textpages.help.videoCallDesc') }}</p>

            <div v-if="!userStore.mobile">
                <h3>{{ $t('textpages.help.stepOneTitle') }}</h3>
                <p>{{ $t('textpages.help.stepOneDesc') }}</p>
                <img alt="steponehelp" style="max-width: 450px" :src="getImageUrl('steponehelp')" />
                
                <h3>{{ $t('textpages.help.stepTwoTitle') }}</h3>
                <p>{{ $t('textpages.help.stepTwoDesc') }}</p>
                <img alt="steptwohelp" style="max-width: 1090px" :src="getImageUrl('steptwohelp')" />
    
                <h3>{{ $t('textpages.help.stepThreeTitle') }}</h3>
                <p>{{ $t('textpages.help.stepThreeDesc') }}</p>
                <img alt="stepthreehelp" style="max-width: 1090px" :src="getImageUrl('stepthreehelp')" />
    
                <h3>{{ $t('textpages.help.stepFourTitle') }}</h3>
                <p>{{ $t('textpages.help.stepFourDesc') }}</p>
                <img alt="stepfourhelp" style="max-width: 1090px" :src="getImageUrl('stepfourhelp')" />
            </div>
        </div>
        <div v-if="localizeStore.hasService('email')" class="textpages__help-content" :class="{'textpages__help-content-mobile': userStore.mobile}">
            <h1>{{ $t('textpages.help.chatTitle') }}</h1>
            <p>{{ $t('textpages.help.chatDesc') }}</p>

            <p>
                {{ $t('textpages.help.messageDesc') }}
            </p>
            <img alt="message" :style="{ 'max-width': userStore.mobile ? '320px' : '797px' }" :src="userStore.mobile ? getImageUrl('messagehelpMobile') : getImageUrl('messagehelp')" />

            <p>
                {{ $t('textpages.help.inputDesc') }}
            </p>
        </div>

        <div class="textpages__help-content" :class="{'textpages__help-content-mobile': userStore.mobile}">
            <h1>{{ $t('textpages.help.notificationsTitle') }}</h1>
            <p  v-html="$t('textpages.help.notificationsDesc')"></p>
            <img alt="alert" :style="{ 'max-width': userStore.mobile ? '320px' : '883px' }" :src="userStore.mobile ? getImageUrl('alerthelpMobile') : getImageUrl('alerthelp')" />
        </div>            
    </div>
</div>
